var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',{staticClass:"tw-pr-10 tw-leading-6",domProps:{"innerHTML":_vm._s(_vm.answer)}})
}
var staticRenderFns = []

export { render, staticRenderFns }